export const WHATS_NEW_URL_LINK =
  'https://faq.allwhere.co/en_us/categories/release-notes-ByJaXpKZh';
